/**
 * Mock-API bootstrap — day-1-unblock kapcsoló.
 *
 * Szabály: a mock CSAK akkor indul, ha **dev-mód** ÉS `VITE_USE_REAL_API !== 'true'`.
 * - `VITE_USE_REAL_API=true` (vagy prod-build) → a worker NEM indul, a valódi `/api/v1` megy.
 * - alapértelmezés (flag hiányzik, dev) → mock-szerver indul, a FE a `@kgc/api-contract`
 *   szerződés szerinti mock-válaszok ellen épül, BE nélkül.
 *
 * Dinamikus import → a `msw/browser` + handlerek NEM kerülnek a production-bundle-be.
 */
export async function startMockApi(): Promise<void> {
  const useRealApi = import.meta.env.VITE_USE_REAL_API === 'true';
  if (!import.meta.env.DEV || useRealApi) return;

  const { worker } = await import('./browser');
  await worker.start({
    onUnhandledRequest: 'bypass', // a nem-mockolt kéréseket átengedi (valódi API / statikus)
    quiet: false,
  });
  // eslint-disable-next-line no-console
  console.info(
    '[mock-api] MSW day-1-unblock mock aktív (VITE_USE_REAL_API!=true). Valódi API: VITE_USE_REAL_API=true'
  );
}
